import React, { useState, useEffect } from "react";
import "../App.css";
import CommentForm from "./CommentForm.jsx";
import helpIcon from "../assets/delete.png";
import StarGen from "../Component/StarSet.jsx";
import "../styles/Homepage.css";
import "../style/Self.css";

import Null_Photo from "../assets/No_Photo.png";
import { useNavigate } from 'react-router-dom';
/* This will render a single post, with all of the options like comments, delete, tags, etc. 
  
    This component takes in a post, a type, and a loadPosts props
    post: the current post to load/display
    type: - postlist if the post itself is the main post (doesn't have a parentId)
          - commentlist if the post is a comment on another post/comment (has a parentId)
    loadPosts: a function passed into the component which is used to load the posts/comments 
              depending on if it is a comment or an original post
*/
const Home_Post = ({ post, type, loadPosts }) => {
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const IMAGE_BASE_URL = isLocalhost ? "" : "https://webdev.cse.buffalo.edu/hci/teams/indecisive";
  
  const [showModal, setShowModal] = useState(false);
  const [showTags, setShowTags] = useState(post.reactions.length > 0);
  const [comments, setComments] = useState(parseInt(post._count.children));
const [rating, setRating] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [postComments, setPostComments] = useState([]);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const postlink = () => {
    // Navigate to another page
    navigate(`/reviewPost/${post.id}`);
  };

  const tagPost = (tag, thisPostID) => {
    //find the appropriate reaction to delete - namely, the one from the current user
    let userReaction = -1;
    post.reactions.forEach((reaction) => {
      if (reaction.reactorID === parseInt(sessionStorage.getItem("user"))) {
        userReaction = reaction.id;
      }
    });

    // if there is one, delete it.
    if (userReaction >= 0) {
      //make the api call to post
      fetch(
        process.env.REACT_APP_API_PATH + "/post-reactions/" + userReaction,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      ).then(
        (result) => {
          loadPosts();
        },
        (error) => {
         
        }
      );
    } else {
      //make the api call to post
      fetch(process.env.REACT_APP_API_PATH + "/post-reactions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          reactorID: sessionStorage.getItem("user"),
          postID: thisPostID,
          name: "like",
        }),
      }).then(
        (result) => {
          loadPosts();
        },
        (error) => {
         
        }
      );
    }
  };

  // function used to update the classname of the comments on a post
  // if the showModal state is true, show the comments, otherwise hide the comments
  const showHideComments = () => {
    return showModal ? "comments show" : "comments hide";
  };

  // function used to update the classname of the tags on a post
  const showHideTags = () => {
    if (showTags) {
      if (post.reactions.length > 0) {
        for (let i = 0; i < post.reactions.length; i++) {
          if (post.reactions[i].reactorID === sessionStorage.getItem("user")) {
            return "tags show tag-active";
          }
        }
      }
      return "tags show";
    }
    return "tags hide";
  };
  const random_pizza = () => {
    if (post.attributes && post.attributes.image && post.attributes.image !== "") {
      const imagePath = post.attributes.image;
      if (imagePath.startsWith("http")) {
        return imagePath; // full URL already
      }
      return `${IMAGE_BASE_URL}${imagePath}`;
    } else {
      return Null_Photo;
    }
  };
  
const pTitle = () => {
  let t="Placeholder title";
  if (post.attributes && post.attributes.title != (null||"")) {
    t=post.attributes.title;
  }
  
  return t;
}


  // Function used to delete a post given a postID in the parameter
  // if the post successfully is deleted, call lostPosts to reload the posts
  // to show all the posts without the deleted post
  const deletePost = (postID) => {
    fetch(process.env.REACT_APP_API_PATH + "/posts/" + postID, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((result) => {
        loadPosts();
      })
      .catch((error) => {
        
      });
  };

  // function used to load the comments of a post given the post id from the props
  const loadComments = () => {
    if (sessionStorage.getItem("token")) {
      let url = process.env.REACT_APP_API_PATH + "/posts?parentID=" + post.id;

      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((result) => {
          if (result) {
            setIsLoaded(true);
            setPostComments(result[0]);
            setComments(result[0].length);
          
          }
        })
        .catch((err) => {
          setIsLoaded(true);
         
          console.log("ERROR loading posts");
        });
    }
  };
  useEffect(() => {
    // Ensure rating is set when the post is loaded
    if (post.attributes) {
      // Check for overallRating first, then fall back to rating if not found
      const postRating = post.attributes.overallRating !== undefined 
        ? post.attributes.overallRating 
        : post.attributes.rating !== undefined 
          ? post.attributes.rating 
          : 0;
      setRating(postRating);
    }
  }, [post]);

  // load the comments of the specific post clicked on
  // loadComments will run when showModal get turned to true when the user clicks on the comment icon
  useEffect(() => {
    loadComments();
  }, [showModal]);

  // Load dish tags from dishes2.json
  useEffect(() => {
    const loadDishTags = async () => {
      if (post.attributes?.dishID) {
        try {
          const dishesData = await import('../assets/dishes2.json');
          const matchingDish = dishesData.default.find(dish => dish.id === Number(post.attributes.dishID));
          if (matchingDish) {
            setCategories(matchingDish.tags || []);
          }
        } catch (error) {
          console.error("Error loading dish tags:", error);
          setCategories([]);
        }
      }
    };

    loadDishTags();
  }, [post.attributes?.dishID]);

  // Function to handle the display of comments and related functionality
  const commentDisplay = () => {
    return (
      <div className="comment-block">
        {/* Tag button */}
        <div className="tag-block">
        
        </div>
       
        {/* Display the number of reactions for a given post */}
       
         {/* Comment indicator and icon */}
        
        {/* Display the comments and CommentForm component */}
        <div className={showHideComments()}>
          <CommentForm
            parent={post.id}
            loadPosts={loadPosts}
            loadComments={loadComments}
          />

          {/* Display existing comments using the same Post component recursively */}
          <div className="posts">
            <div>
              {/* Check if there are comments before mapping through them */}
              {postComments.length > 0 &&
                postComments.map((comment) => (
                  <Home_Post
                    key={comment.id}
                    post={comment} // pass in the comment as the post to recursively get all the comments (comments of a comment)
                    type="commentlist" // Indicate that this is a comment of a post
                    loadPosts={loadComments} // Function to reload comments for this post
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  };
 
  // Function to display the delete icon if the user is the author of post
  const showDelete = () => {
    if (post.authorID === parseInt(sessionStorage.getItem("user"))) {
      return (
        <img
          src={helpIcon}
          className="sidenav-icon deleteIcon"
          alt="Delete Post"
          title="Delete Post"
          onClick={() => deletePost(post.id)}
        />
      );
    }
    return null;
  };
  const rest = () => {
    let x="N/A"
    if (post.attributes && post.attributes.restaurant  !==  (null||"")) {
        x=post.attributes.restaurant;
    }
    return x;
  }




 

  // Render the main post body with author information, delete icon (if applicable),
  // post content, and the comment display section including tags, reactions, and comments.
  return (
    <div>
    <div key={post.id} className={[type, "postbody"].join(" ")} onClick={postlink}>
       <head>
      <link rel="preconnect" href="https://fonts.googleapis.com"></link>
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
<link href="https://fonts.googleapis.com/css2?family=Fredericka+the+Great&family=Fredoka:wght@500&family=Urbanist:ital,wght@0,500;1,500&display=swap" rel="stylesheet"></link>
      </head>
        <img src={random_pizza()} class="d-img"></img>
        <div class="post-space">
         <div className="tags-container" style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
            marginBottom: '12px'
         }}>
            {categories.map((category, index) => {
              const tagType = category.toLowerCase().replace(/\s+/g, '-');
              let backgroundColor = '#e2e8f0';
              let textColor = '#4a5568';

              // Spice Level Colors
              if (tagType === 'hot') {
                backgroundColor = '#ffcdd2';
                textColor = '#c62828';
              } else if (tagType === 'medium') {
                backgroundColor = '#ffe0b2';
                textColor = '#ef6c00';
              } else if (tagType === 'mild') {
                backgroundColor = '#fff9c4';
                textColor = '#f57f17';
              } else if (tagType === 'no-spice') {
                backgroundColor = '#cfd8dc';
                textColor = '#455a64';
              }
              // Dietary Colors
              else if (tagType === 'veggie' || tagType === 'vegetarian' || tagType === 'vegan') {
                backgroundColor = '#c8e6c9';
                textColor = '#2e7d32';
              } else if (tagType === 'gluten-free') {
                backgroundColor = '#bbdefb';
                textColor = '#0d47a1';
              } else if (tagType === 'soy-free') {
                backgroundColor = '#e1bee7';
                textColor = '#6a1b9a';
              } else if (tagType === 'dairy-free') {
                backgroundColor = '#ffccbc';
                textColor = '#d84315';
              } else if (tagType === 'nut-free') {
                backgroundColor = '#d1c4e9';
                textColor = '#4527a0';
              }
              // Cuisine Colors
              else if (tagType === 'mexican') {
                backgroundColor = '#FFECB3';
                textColor = '#FF8F00';
              } else if (tagType === 'chinese') {
                backgroundColor = '#FFCDD2';
                textColor = '#B71C1C';
              } else if (tagType === 'japanese') {
                backgroundColor = '#F3E5F5';
                textColor = '#6A1B9A';
              } else if (tagType === 'korean') {
                backgroundColor = '#B2EBF2';
                textColor = '#00838F';
              } else if (tagType === 'indian') {
                backgroundColor = '#FFECB3';
                textColor = '#E65100';
              } else if (tagType === 'american') {
                backgroundColor = '#C5CAE9';
                textColor = '#283593';
              } else if (tagType === 'italian') {
                backgroundColor = '#DCEDC8';
                textColor = '#558B2F';
              }
              // Contains/Allergens
              else if (tagType === 'contains-seafood') {
                backgroundColor = '#b2dfdb';
                textColor = '#00695c';
              }

              return (
                <span 
                  key={index}
                  style={{
                    backgroundColor: backgroundColor,
                    color: textColor,
                    padding: '4px 12px',
                    borderRadius: '4px',
                    fontSize: '0.85em',
                    fontFamily: "'Urbanist', sans-serif",
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    lineHeight: '1.3'
                  }}
                  onClick={(e) => e.stopPropagation()} // Prevent post click when clicking tags
                >
                  {category}
                </span>
              );
            })}
         </div>
         <div className="dish-info">
        <h2 >{pTitle()}</h2>
        
      <div class="rating"> <StarGen rating={rating}></StarGen></div>
     
     <p > {post.content}</p>
      {commentDisplay()}
      <p><strong>{rest()}</strong></p>
    
    </div>
    </div>
    </div>
    {/*<img class="more" src={Option} ></img>*/}
   
    </div>
  );
};

export default Home_Post;
